export default {
  state: {
    flight: {
      pickup: {
        title: ''
      },
      dropoff: {
        title: ''
      },
      nearestAirport: [],
      flightPrice: {
        loading: false,
        error: ''
      }
    }
  },
  mutations: {
    setFlightData (state, data) {
      for (let field in data) {
        state.flight[field] = data[field]
      }
    },
    setFlightPriceData (state, data) {
      for (let field in data) {
        state.flight.flightPrice[field] = data[field]
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/reservation/flight.js